import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleNavigation = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className="gvs-footer">
      <div className="gvs-footer-content">
        <div className="gvs-footer-brand">
          <img
            src="/Gimbiya.png"
            alt="Gimbiya Value Store"
            className="gvs-footer-logo"
          />

          <p>
            Your trusted destination for quality products at value prices.
          </p>
        </div>

        <div className="gvs-footer-section">
          <h3>Quick Links</h3>

          <Link to="/" onClick={handleNavigation}>
            Home
          </Link>

          <Link to="/products" onClick={handleNavigation}>
            Products
          </Link>

          <Link to="/login" onClick={handleNavigation}>
            Login
          </Link>

          <Link to="/register" onClick={handleNavigation}>
            Create Account
          </Link>

          <Link to="/about" onClick={handleNavigation}>
            About Us
          </Link>

          <Link to="/contact" onClick={handleNavigation}>
            Contact Us
          </Link>
        </div>

        <div className="gvs-footer-section">
          <h3>Customer Information</h3>

          <Link to="/faqs" onClick={handleNavigation}>
            FAQs
          </Link>

          <Link to="/shipping-returns" onClick={handleNavigation}>
            Shipping & Returns
          </Link>

          <Link to="/refund-policy" onClick={handleNavigation}>
            Refund Policy
          </Link>
        </div>

        <div className="gvs-footer-section">
          <h3>Legal</h3>

          <Link to="/privacy" onClick={handleNavigation}>
            Privacy Policy
          </Link>

          <Link to="/terms" onClick={handleNavigation}>
            Terms & Conditions
          </Link>
        </div>
      </div>

      <div className="gvs-footer-bottom">
        <p>
          Developed by <strong>BTO</strong>
        </p>

        <p>
          © {currentYear} Gimbiya Value Store. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;